export default __webpack_public_path__ + "static/media/imagedefault.f7e9d84a.jpg";